// Stops trackpad side-swipes on the archive page from triggering browser back/forward navigation.
// Swipes inside an image strip still scroll it; only the overflow past its edges is swallowed.
class KmSwipeGuard extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    window.addEventListener('wheel', (event) => this.onWheel(event), {
      passive: false,
      signal: this.controller.signal,
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onWheel(event) {
    // Only act on mostly-sideways gestures; vertical page scrolling is untouched.
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

    const scroller = this.findScroller(event.target);
    if (!scroller) {
      event.preventDefault();
      return;
    }

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    // RTL scrollers report negative scrollLeft, so compare against the absolute position.
    const position = Math.abs(scroller.scrollLeft);
    const goingBack = event.deltaX < 0;
    const isRtl = getComputedStyle(scroller).direction === 'rtl';
    const towardStart = isRtl ? !goingBack : goingBack;

    if (towardStart && position <= 1) event.preventDefault();
    if (!towardStart && position >= maxScroll - 1) event.preventDefault();
  }

  findScroller(node) {
    let element = node instanceof Element ? node : null;
    while (element && element !== document.body) {
      const style = getComputedStyle(element);
      const scrollsSideways = /(auto|scroll)/.test(style.overflowX) && element.scrollWidth > element.clientWidth;
      if (scrollsSideways) return element;
      element = element.parentElement;
    }
    return null;
  }
}

if (!customElements.get('km-swipe-guard')) customElements.define('km-swipe-guard', KmSwipeGuard);
